module.exports = __webpack_public_path__ + "img/dataIcon4.062e273e.svg";